"use client";

import Image from "next/image";
import * as React from "react";

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export interface TableEmptyStateProps {
  title: string;
  description?: string;
  image?: {
    src: string;
    alt: string;
    width?: number;
    height?: number;
  };
  action?: React.ReactNode;
}

export function TableEmptyState({
  title,
  description,
  image,
  action,
}: TableEmptyStateProps) {
  return (
    <div className="flex min-h-auto items-center justify-center py-10">
      <Empty>
        <EmptyHeader>
          {image ? (
            <EmptyMedia variant="default">
              <Image
                src={image.src}
                alt={image.alt}
                width={image.width ?? 80}
                height={image.height ?? 80}
                className={`object-contain ${image.width && image.height ? "" : "size-20"}`}
              />
            </EmptyMedia>
          ) : null}
          <EmptyTitle>{title}</EmptyTitle>
          {description ? (
            <EmptyDescription>{description}</EmptyDescription>
          ) : null}
        </EmptyHeader>
        {action ? <EmptyContent>{action}</EmptyContent> : null}
      </Empty>
    </div>
  );
}


